export const Support = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.416 4.58366L12.3876 7.61209M7.60676 12.3929L4.58268 15.417M4.58268 4.58366L7.60676 7.60774M12.3876 12.3886L15.416 15.417M17.7077 10.0003C17.7077 14.2575 14.2565 17.7087 9.99935 17.7087C5.74215 17.7087 2.29102 14.2575 2.29102 10.0003C2.29102 5.74313 5.74215 2.29199 9.99935 2.29199C14.2565 2.29199 17.7077 5.74313 17.7077 10.0003ZM13.541 10.0003C13.541 11.9563 11.9554 13.542 9.99935 13.542C8.04334 13.542 6.45768 11.9563 6.45768 10.0003C6.45768 8.04432 8.04334 6.45866 9.99935 6.45866C11.9554 6.45866 13.541 8.04432 13.541 10.0003Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)

export default Support
